import { Routes } from '@angular/router';
import {AuthGuard} from "@auth0/auth0-angular";
import {everywhereGuard} from "./guards/everywhere.guard";
import {customerGuard} from "./guards/customer.guard";
import {ValidateImeiComponent} from "./actions/validate-imei/validate-imei.component";
import {HomeComponent} from "./views/home/home.component";
import {OrdersPageComponent} from "./views/orders-page/orders-page.component";
import {OrderFormComponent} from "./actions/order-form/order-form.component";
import {CreateCustomerComponent} from "./actions/create-customer/create-customer.component";
import {BulkActionsComponent} from "./views/bulk-action/bulk-actions/bulk-actions.component";
import {BulkActionDetailComponent} from "./views/bulk-action/bulk-action-detail/bulk-action-detail.component";
import {GatewayComponent} from "./views/gateway/gateway.component";
import {GatewayOrderDetailComponent} from "./views/gateway/gateway-order-detail/gateway-order-detail.component";

const routeConfig: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: "full"
  },
  {
    path: 'order-form',
    component: OrderFormComponent,
    title: 'Order Form',
    canActivate: [AuthGuard, customerGuard]
  },
  {
    path: 'home',
    component: HomeComponent,
    title: 'Home',
    canActivate: [AuthGuard, everywhereGuard]
  },
  {
    path: 'validate',
    component: ValidateImeiComponent,
    title: 'Validate',
    canActivate: [AuthGuard, everywhereGuard]
  },
  {
    path: 'orders',
    component: OrdersPageComponent,
    title: 'Orders',
    canActivate: [AuthGuard, everywhereGuard]
  },
  {
    path: 'gateway',
    children: [
      {
        path: '',
        component: GatewayComponent,
        title: 'Gateway',
        canActivate: [AuthGuard, everywhereGuard]
      },
      {
        path: ':id',
        component: GatewayOrderDetailComponent,
        title: 'Gateway Order',
        canActivate: [AuthGuard, everywhereGuard]
      }
    ]
  },
  {
    path: 'create-customer',
    component: CreateCustomerComponent,
    title: 'Create Customer',
    canActivate: [AuthGuard, everywhereGuard]
  },
  {
    path: 'bulk-actions',
    children: [
      {
        path: '',
        component: BulkActionsComponent,
        title: 'Bulk Actions',
        canActivate: [AuthGuard, everywhereGuard]
      },
      {
        path: ':id',
        component: BulkActionDetailComponent,
        canActivate: [AuthGuard, everywhereGuard]
      }
    ]
  }
];

export default routeConfig;
